export const isProgramArchived = (program) =>
  Boolean(program?.archivedAt || program?.state === 'DELETED')

export const isLegacyArchivedProgram = (program) =>
  program?.state === 'DELETED'

export const canManageProgramArchive = (user) =>
  user?.role === 'ADMINISTRADOR'
